import { DrawerHeaderWrapper } from '../Components.styled'
import classNames from 'classnames/bind'
import styles from './DrawerHeader.module.scss'
import { Link } from 'react-router-dom'
import { useAppSelector } from '~/app/hooks'
import { currentTheme, drawerSetting, isDarkTheme } from '~/redux/features'
import { logoDarkTheme, logoLightTheme } from '~/assets/images'
import { IconButton } from '@mui/material'
import { BackIcon, ForwardIcon } from '~/components/EFIcons'
import { useMobileView } from '~/hooks/useMobileView'

const cx = classNames.bind(styles)

interface IDrawerHeaderProps {
  handleDrawerClose: () => void
  handleDrawerOpen: () => void
}
export const DrawerHeader = ({
  handleDrawerClose,
  handleDrawerOpen
}: IDrawerHeaderProps) => {
  const isMobile = useMobileView()
  const isDark = useAppSelector(isDarkTheme)
  const theme = useAppSelector(currentTheme)
  const { isShowDrawer } = useAppSelector(drawerSetting)
  return (
    <DrawerHeaderWrapper>
      <div className={cx('nav-header-wrapper', { center: !isShowDrawer })}>
        {isShowDrawer ? (
          <>
            <Link to='/'>
              <img
                src={isDark ? logoDarkTheme : logoLightTheme}
                alt='logo'
                className={cx('drawer-logo')}
              />
            </Link>
            <div className={cx('toggle-button', theme)}>
              <IconButton
                disableRipple
                id='btn-close-drawer'
                onClick={handleDrawerClose}
                className={cx('icon-toggle', theme)}
              >
                <BackIcon />
              </IconButton>
            </div>
          </>
        ) : (
          <div className={cx('toggle-button', isMobile ? 'hide' : '', theme)}>
            <IconButton
              disableRipple
              id='btn-open-drawer'
              onClick={handleDrawerOpen}
              className={cx('icon-toggle', theme)}
            >
              <ForwardIcon />
            </IconButton>
          </div>
        )}
      </div>
    </DrawerHeaderWrapper>
  )
}
